export enum MeetingType {
  MeetOrPickup = 'MEET_ON_LOCATION_OR_PICK_UP',
  Meet = 'MEET_ON_LOCATION',
  Pickup = 'PICK_UP'
}
